'use client';

import React from 'react';
import type {
  Artwork,
  Nftcollection,
  LandscapeExhibition,
  Exhibition,
  Immersive,
  Installation,
  Physicalartwork,
} from '@/types';
import { CatalogCard } from '../catalog-card';
import { artworkToCatalogItem } from '@/lib/services/catalog/artwork.service';
import { nftCollectionToCatalogItemSync } from '@/lib/services/catalog/nftcollection.service';
import { exhibitionToCatalogItem } from '@/lib/services/catalog/exhibitions.service';
import { immersiveToCatalogItem } from '@/lib/services/catalog/immersives.service';
import { installationToCatalogItem } from '@/lib/services/catalog/installations.service';
import { physicalToCatalogItem } from '@/lib/services/catalog/physicals.service';

interface LandscapeExhibitionProps {
  layout: LandscapeExhibition;
}

export const Landscape_Exhibition: React.FC<LandscapeExhibitionProps> = ({ layout }) => {
  const renderCatalogCard = (item: Artwork | Nftcollection | Exhibition | Immersive | Installation | Physicalartwork, relationTo: string) => {
    let res;
    switch (relationTo) {
      case 'artworks':
        res = artworkToCatalogItem(item as Artwork);
        return <CatalogCard artwork={res} onEnlarge={() => {}} />;
      case 'nftcollections':
        res = nftCollectionToCatalogItemSync(item as Nftcollection);
        return <CatalogCard artwork={res} onEnlarge={() => {}} />;
      case 'exhibitions':
        res = exhibitionToCatalogItem(item as Exhibition);
        return <CatalogCard artwork={res} onEnlarge={() => {}} />;
      case 'immersives':
        res = immersiveToCatalogItem(item as Immersive);
        return <CatalogCard artwork={res} onEnlarge={() => {}} />;
      case 'installations':
        res = installationToCatalogItem(item as Installation);
        return <CatalogCard artwork={res} onEnlarge={() => {}} />;
      case 'physicalartworks':
        res = physicalToCatalogItem(item as Physicalartwork);
        return <CatalogCard artwork={res} onEnlarge={() => {}} />;
      default:
        return null;
    }
  };

  return (
    <section className="w-full p-[15px] rounded-md bg-white mb-[12px] flex flex-col justify-between relative">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
        <div className="lg:pr-16 order-2 lg:order-1">
          <h3 className="text-[10px] font-mono text-gray-900 mb-4">[ {layout.leftTitle} ]</h3>
          <div className="space-y-4 text-[10px] leading-relaxed">
            {layout.items.map((item, index1) => (
              <div key={index1}>
                <h4 className="text-[10px] font-mono text-gray-800 mb-2">{item.title}</h4>
                {item.description.split('\n').map((paragraph, index2) => (
                  <p key={index2} className="text-[10px] font-mono text-gray-700 mb-0">
                    {paragraph}
                  </p>
                ))}
              </div>
            ))}
          </div>
        </div>
        <div className="order-1 lg:order-2">
          <h3 className="text-[10px] font-mono text-gray-900 mb-4">[ {layout.rightTitle} ]</h3>
          {/* Content */}
          {layout.relatedItems?.map((relatedItemGroup, groupIndex) => (
            <div
              key={`group-${groupIndex}`}
              className={`my-4 grid gap-x-3 gap-y-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 ${
                relatedItemGroup.items?.length === 5
                  ? 'xl:grid-cols-4'
                  : relatedItemGroup.items?.length === 6
                    ? 'xl:grid-cols-4'
                    : relatedItemGroup.items?.length === 7
                      ? 'xl:grid-cols-4'
                      : relatedItemGroup.items?.length === 8
                        ? 'xl:grid-cols-4'
                        : relatedItemGroup.items?.length === 9
                          ? 'xl:grid-cols-4'
                          : relatedItemGroup.items?.length >= 10
                            ? 'xl:grid-cols-4'
                            : 'xl:grid-cols-4'
              }`}
            >
              {relatedItemGroup.items?.map((item, itemIndex) => {
                // Determine what type of item we're dealing with
                const relationTo = item.relationTo;
                const value = item.value;

                return (
                  <div key={`item-${groupIndex}-${itemIndex}`} className="mb-4">
                    {/* Render based on relationTo type */}
                    {typeof value === 'object' && <div>{renderCatalogCard(value, relationTo)}</div>}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
